import React from 'react'
import styles from './button.module.scss'

const types = {
  primary: 'primary',
  secondary: 'secondary',
  addon: 'addon',
  minimal: 'minimal',
  minimalDestructive: 'minimalDestructive',
  addonActive: 'addonActive',
  tertiary: 'tertiary',
  tertiaryDark: 'tertiaryDark',
  destructive: 'destructive'
}

const sizes = {
  large: 'large',
  extraSmall: 'extraSmall',
  small: 'small',
}

interface IProps {
  label?: string,
  type: keyof typeof types,
  size?: keyof typeof sizes,
  handleClick?: any,
  modifiers?: string
  tooltip?: string
  href?: string
  title?: string
  children?: any
  loading?: boolean
  active?: boolean
  disabled?: boolean
  iconLeft?: any
  submit?: boolean
}

const Button = React.memo(function Button({ size = 'large', label, type, handleClick, modifiers, active, disabled, iconLeft, title, children, tooltip, loading, submit, href }: IProps) {
  const El = href ? 'a' : 'button'
  return (
    <El
      className={`${styles.button} ${styles[types[type]]} ${styles[sizes[size]]} ${modifiers ? modifiers : ''} ${active ? styles.addonActive : ''}
      ${tooltip ? styles.tooltip : ''} 
      ${loading ? 'tw-opacity-100' : ''}`}
      onClick={(e) => handleClick ? handleClick(e) : {}}
      type={submit ? 'submit' : 'button'}
      data-title={tooltip ? tooltip : ''}
      title={title}
      href={href}
      disabled={disabled || loading}
    >
      {iconLeft && <span className={`${styles.IconLeft} ${size === 'small' ? styles.iconLeftSmall : ''}`} aria-hidden="true">
        {iconLeft}
      </span>}
      {loading &&
        <svg className={`${styles.spinner} ${type === 'destructive' ? styles.spinnerRed : ''}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>}
      {loading ? <span>Et øjeblik</span> : children || label}
    </El>
  )
})

export default Button
